// extracted by mini-css-extract-plugin
module.exports = {"AddNewItem":"AddNewItem__AddNewItem--J7cpz","AddButton":"AddNewItem__AddButton--3RoyQ","ButtonTitle":"AddNewItem__ButtonTitle--35nmA"};